import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { IconButton, Typography } from '@mui/material';

import WorkerReportIcon from '../../../../assets/icons/WorkerReportIcon';
import CommonTooltip from '../../../../components/Tooltip/Tooltip';
import { BLACK } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const WorkerReportButton = ({ isOpen, onClick }) => (
  <CommonTooltip
    title={
      <Typography
        sx={{
          fontFamily: PRIMARY_FONT[400],
          fontSize: '14px',
          color: BLACK[60],
          textAlign: 'center',
        }}
      >
        {LanguageConverter('jobOrder.roster.workerReport')}
      </Typography>
    }
    placement="top"
    bgcolor={BLACK[0]}
    enterDelay={200}
  >
    <IconButton
      aria-label={LanguageConverter('jobOrder.roster.workerReport')}
      onClick={onClick}
      sx={{ '&:hover': { backgroundColor: 'transparent' } }}
    >
      <WorkerReportIcon isOpen={isOpen} />
    </IconButton>
  </CommonTooltip>
);

WorkerReportButton.propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

export default WorkerReportButton;
